<template>
  <div class="row justify-content-md-center">
    <div v-if="isLoading">
      <OtherLoading />
    </div>
    <div v-else class="p-4 page-content col-md-11 col-12">
      <div>
        <div class="header-tablepage">Product Detail</div>
        <div class="">Product Name : {{ form.name }}</div>
      </div>

      <b-tabs v-model="tebIndex" class="my-2">
        <b-tab title="Information">
          <div class="bg-tabs d-flex justify-content-between">
            <div>General Information</div>
            <div>
              Last Update :
              {{ $moment(form.updated_time).format("DD/MM/YY") }}
              ({{ $moment(form.updated_time).format("HH:mm:ss") }})
            </div>
          </div>
          <div class="px-4">
            <b-row>
              <b-col
                v-for="(field, index) in productFields"
                :key="`field-${index}`"
                :md="field.isFullRow ? 12 : 6"
                cols="12"
                class="mt-3"
              >
                <label class="font-weight-bold">{{ field.label }}</label>
                <p class="text-gray">
                  <template v-if="field.isNumber">
                    {{ form[field.key] | numeral("0,0.00") }}
                  </template>
                  <template v-else>
                    {{ form[field.key] || "-" }}
                  </template>
                </p>
              </b-col>

              <!-- Checkbox (แยกออกต่างหาก เพราะไม่เหมือน field อื่น) -->
              <b-col cols="6" class="mt-3">
                <b-form-checkbox
                  v-model="form.is_serial"
                  switch
                  disabled
                  :value="1"
                  :unchecked-value="0"
                >
                  Serial
                </b-form-checkbox>
              </b-col>
            </b-row>
          </div>
          <div class="mt-3 bg-tabs d-flex justify-content-between">
            <div>Additional Information</div>
            <div>
              Last Update :
              {{ $moment(form.updated_time).format("DD/MM/YY") }}
              ({{ $moment(form.updated_time).format("HH:mm:ss") }})
            </div>
          </div>
          <b-row class="px-4">
            <template v-for="(item, index) in customFieds">
              <b-col
                v-if="item.field_type_id == 7"
                md="6"
                cols="12"
                class="mt-3"
                :key="`additional-${index}`"
              >
                <label class="font-weight-bold">{{ item.name }}</label>
                <p class="text-gray">
                  {{
                    item.value ? $moment(item.value).format("DD/MM/YY") : "-"
                  }}
                </p>
              </b-col>
              <b-col
                v-else-if="item.field_type_id == 8"
                md="6"
                cols="12"
                class="mt-3"
                :key="`additional-${index}`"
              >
                <label class="font-weight-bold">{{ item.name }}</label>
                <div v-if="item.value">
                  <img :src="item.value" class="img-size-m" />
                </div>
                <div v-else>-</div>
              </b-col>
              <b-col
                v-else-if="item.field_type_id == 5"
                md="6"
                cols="12"
                class="mt-3"
                :key="`additional-${index}`"
              >
                <label class="font-weight-bold">{{ item.name }}</label>
                <p class="text-gray">
                  {{
                    item.value
                      ? $moment(item.value).format($formatDateNewFull)
                      : "-"
                  }}
                </p>
              </b-col>
              <b-col
                v-else
                md="6"
                cols="12"
                class="mt-3"
                :key="`additional-${index}`"
              >
                <label class="font-weight-bold">{{ item.name }}</label>
                <p class="text-gray">
                  {{ item.value || "-" }}
                </p>
              </b-col>
            </template>
          </b-row>
        </b-tab>
        <!-- <b-tab title="ข้อมูลเพิ่มเติม" disabled></b-tab> -->
        <b-tab
          v-for="(tab, index) in customObjects"
          :key="`customObjects-${index}`"
          :title="tab.custom_object_name"
        >
          <div class="p-3">
            <div  v-if="tab.answers.length > 0">
              <b-row  class="card-body " v-for="(item, index) in tab.answers" :key="index" :class="{'mt-3': index > 0}">
                <b-col
                  cols="6"
                  v-for="(anws, index) in item.answer_detail"
                  :key="index"
                >
                  <div class="font-weight-bold">
                    {{ anws.name }} :
                    <span class="text-gray">{{ anws.value || "-" }}</span>
                  </div>
                </b-col>
              </b-row>
            </div>
            <div
              v-else
              class="text-center justify-content-center card-body-disabled full-height d-flex align-items-center"
            >
              ไม่พบข้อมูล
            </div>
          </div>
        </b-tab>
        <b-tab title="Inventory" :branchList="branchList">
          <InventoryIndex :branchList="branchList"></InventoryIndex>
        </b-tab>
        <b-tab title="Serial">
          <SerialIndex :branchList="branchList"></SerialIndex>
        </b-tab>
        <b-tab title="Serial History">
          <SerialHistoryIndex :branchList="branchList"></SerialHistoryIndex>
        </b-tab>
        <b-tab title="Collection">
          <CollectionIndex :branchList="branchList"></CollectionIndex>
        </b-tab>
        <b-tab title="Related Product">
          <RelatedProduct></RelatedProduct>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import OtherLoading from "@/components/loading/OtherLoading";
import { mapGetters } from "vuex";
import RelatedProduct from "./components/RelatedProduct.vue";
import CollectionIndex from "./components/collection/index.vue";

import SerialIndex from "./components/serial/index.vue";
import InventoryIndex from "./components/Inventory/index.vue";
import SerialHistoryIndex from "./components/serialHistory/index.vue";

export default {
  components: {
    OtherLoading,
    RelatedProduct,
    SerialIndex,
    InventoryIndex,
    SerialHistoryIndex,
    CollectionIndex,
  },
  computed: {
    ...mapGetters({
      branchId: "getBranchId",
    }),
  },
  name: "Product",
  data() {
    return {
      tebIndex: 0,
      isLoading: false,
      filter: { search: "", page: 1, take: 10, branch_id: "" },
      items: [],
      isBusy: false,
      rows: 0,
      productFields: [
        { label: "Product Name", key: "name" },
        { label: "Product Price (Baht)", key: "price", isNumber: true },
        { label: "Product Code", key: "article_no" },
        { label: "Barcode", key: "barcode" },
        { label: "Manufacturer", key: "product_manufacturer" },
        { label: "Cost", key: "cost", isNumber: true },
        { label: "Weight", key: "weight", isNumber: true },
        { label: "Price Calculation Model", key: "price_calculation_model" },
        { label: "Product Brand", key: "product_brand" },
        { label: "Sales Status", key: "product_sale_status" },
        { label: "Product Model", key: "product_model" },
        { label: "Product Sub Model", key: "product_sub_model" },
        { label: "Product Detail", key: "description", isFullRow: true },
      ],
      pageOptions: [
        { value: 5, text: "5 / page" },
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
      fields: [
        {
          key: "image_url",
          label: "รูป",
          thClass: "w-1",
        },
        {
          key: "name",
          label: "Name / Code / Type ",
          class: "text-left",
          thClass: "w-1",
        },

        {
          key: "barcode",
          label: "Barcode",
          thClass: "w-1",
        },
        {
          key: "price",
          label: "ราคา ",
          thClass: "w-1",
        },
        {
          key: "stock",
          label: "จำนวน",
          thClass: "w-1",
        },
      ],
      id: this.$route.params.id,
      form: {},
      customFieds: [],
      branchList: [],
      customObjects: [],
    };
  },
  async created() {
    await Promise.all([
      this.getList(),
      this.getProductDetail(),
      this.getBranchList(),
      this.getCustomObject(),
    ]);
  },
  methods: {
    async getList() {
      this.isLoading = true;
      this.isBusy = true;
      this.filter.branch_id = this.branchId;
      const res = await this.axios.post(
        `${this.$baseUrl}/product/get_branch_product_stock`,
        this.filter
      );
      if (res.result == 1) {
        this.isLoading = false;
        this.items = res.detail.branch_product_stock_list;
        this.rows = res.detail.count;
      }

      this.isBusy = false;
    },
    async getCustomObject() {
      const res = await this.axios(
        `${this.$baseUrl}/product/get_product_custom_object/answer/${this.id}`
      );
      this.customObjects = res.detail.map((obj) => {
        const answers = obj.answers.map((answer) => {
          const transformedDetails = answer.answer_detail.map((field) => {
            return this.transformField(field, field.value);
          });

          return {
            ...answer,
            answer_detail: transformedDetails,
          };
        });

        return {
          ...obj,
          answers,
        };
      });
    },
    async getProductDetail() {
      const res = await this.axios(
        `${this.$baseUrl}/product/get_product_detail/${this.id}`
      );
      this.form = res.detail;

      const answerMap = this.form.custom_field.answers.reduce((acc, cur) => {
        acc[cur.product_custom_field_id] = cur.value;
        return acc;
      }, {});

      this.customFieds = this.form.custom_field.fields.map((field) => {
        const rawValue = answerMap[field.id];
        return this.transformField(field, rawValue);
      });
    },

    transformField(field, rawValue) {
      if (field.field_type_id === 3 && field.field_choices && rawValue) {
        const values = String(rawValue).split(",");
        const names = values
          .map((val) => {
            const choice = field.field_choices.find(
              (choice) => String(choice.id) === val.trim()
            );
            return choice ? choice.name : null;
          })
          .filter((name) => name);
        return {
          ...field,
          value: names.join(", "),
        };
      }

      if (field.field_type_id === 4 && field.field_choices && rawValue) {
        const choice = field.field_choices.find(
          (choice) => String(choice.id) === String(rawValue)
        );
        return {
          ...field,
          value: choice ? choice.name : "",
        };
      }

      return {
        ...field,
        value: rawValue || "",
      };
    },
    async handleSearch() {
      this.filter.page = 1;
      await this.getList();
    },
    pagination(page) {
      this.filter.page = page;

      this.getList();
    },
    handleChangeTake(value) {
      this.filter.page = 1;
      this.filter.take = value;

      this.getList();
    },
    async getBranchList() {
      const data = await this.axios(
        `${this.$baseUrl}/inventory/GetBranchs/${this.id}`
      );
      this.branchList = data.detail;
    },
  },
};
</script>
<style lang="scss" scoped>
.img-size-m {
  width: 100px;
  height: 100px;
}

.card-body {
  border-style: dashed;
  border-color: var(--primary-color);
  border-width: 1px;
  border-radius: 8px;
}
.card-body-disabled {
  border-style: dashed;
  border-color: gray;
  border-width: 1px;
  border-radius: 8px;
  opacity: 0.5;
}
.full-height {
  height: 70vh;
}
</style>
